<template>
  <span>
    <div v-if="countList && countList.length > 0">
      <aggridCount flag="footer" :count-list="countList" />
    </div>
    <el-checkbox
      v-else
      :checked="isChecked"
      :disabled="selectedDisabled"
      @change="handleCheckAllChange"
    />
  </span>
</template>

<script>
import aggridCount from '../CommonAgGrid/src/gridTotal'
export default {
  components: { aggridCount },
  computed: {
    selectedDisabled() {
      return this.params.data._selectedDisabled
    },
    countList() {
      return this.params.data._childCount
    },
    isChecked() {
      const { apiKey = 'gridApi' } = this.params.context
      const fatherapi = this.params.context.componentParent[apiKey]

      if (!fatherapi) {
        throw new Error('请确认父组件的componentParent指向的gridApi是否存在')
      }
      const selected = fatherapi.getRowNode(this.params.data.parentId).data
        ._selectedKeys
      // !!selected.length &&
      return selected.includes(
        this.params.data[this.params.context.childRowKey]
      )
    }
  },
  methods: {
    handleCheckAllChange(e) {
      const {
        childrenListKey = '_details',
        apiKey = 'gridApi',
        childRowKey,
        componentParent
      } = this.params.context
      const fatherapi = componentParent[apiKey]
      const rowClassName = '.ag-pinned-left-cols-container .ag-details-row'
      // 本身
      this.params.node.selected = e
      const isFullRow = componentParent.gridOptions.embedFullWidthRows
      const detail_row = isFullRow
        ? document.querySelectorAll(
          rowClassName
        )
        : null
      // 循环主表
      fatherapi.forEachNode((node) => {
        if (this.params.data.parentId === node.id) {
          if (e) {
            node.data._selectedKeys.push(this.params.data[childRowKey])
          } else {
            node.data._selectedKeys = node.data._selectedKeys.filter(
              (item) => item !== this.params.data[childRowKey]
            )
          }
          if (detail_row) {
            this.findEl(
              detail_row,
              node.detailNode.id,
              this.params.node.rowIndex,
              e ? 'add' : 'remove'
            )
          }
          node.data._selected =
            node.data._selectedKeys.length === node.data[childrenListKey].length
        }
      })
      const rowsToUpdate = fatherapi
        .getRenderedNodes()
        .filter((node) => node.data.parentId === this.params.data.parentId)
      this.params.api.refreshCells({ rows: rowsToUpdate, force: true })
      fatherapi.refreshCells({ force: true })
    },
    findEl(domList, customer_id, subIndex, type) {
      const parentSelector = `[row-id="${customer_id}"]`
      const parentEl = Array.from(domList).find(el => el.parentElement?.matches(parentSelector))
      if (!parentEl) return

      const el = parentEl.children[subIndex]
      el?.classList[type]?.('ag-row-focus', 'ag-row-selected')
    }
  }
}
</script>
